export default "<div ng-repeat=\"color in vm.colors\" class=\"color-scheme-swatch\" ng-style=\"{ 'background-color': color.bgColor }\"></div> ";